export default __webpack_public_path__ + "static/media/shortlist_what_you_like.8b303803.svg";